// src/pages/user/Mycart.jsx
import React, { useState, useEffect } from 'react';
import styles from './Mycart.module.css';
import Usrnav from '../../usercomponents/Usrnav/Usrnav';
import Cartcontainer from '../../usercomponents/Cartcontainer/Cartcontainer';
import config from '../../config/config';
import axios from 'axios';

const MyCart = () => {
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCart = async () => {
    const token = localStorage.getItem('token');
    
    if (!token) {
      setCartItems([]);
      setLoading(false);
      return;
    }
  
    try {
      const response = await axios.get(`${config.apiBaseUrl}/api/users/cart`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCartItems(response.data);
    } catch (error) {
      console.error('Failed to fetch cart:', error);
      setCartItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCart();
  }, []);

  const updateCart = (newCartItems) => {
    setCartItems(newCartItems);
  };

  return (
    <div className={styles.mctcont}>
      <div className={styles.usrcarttop}>
        <div className="nav-wrapper">
          <Usrnav />
        </div>
      </div>

      <div className={styles.myCartPage}>
        <h1 className={styles.pageTitle}>🛒 My Cart</h1>
        {/* Cart items list */}
        <Cartcontainer 
          cartItems={cartItems} 
          updateCart={updateCart} 
          loading={loading}
        />
      </div>
    </div>
  );
};

export default MyCart;